import React, { PropTypes, Component } from 'react';
import Slide from './components/Slide';
import Arrow from './components/Arrow';
import styles from './index.scss';
import { isSupported as isTransitionSupported } from '../../modules/css-transition';

const nextIndex = (currIndex, length) => {
  if(currIndex < length - 1) {
    return currIndex + 1;
  } else if(currIndex === length - 1) {
    return 0;
  }
  return -1;
};

const prevIndex = (currIndex, length) => {
  if(currIndex > 0) {
    return currIndex - 1;
  } else if(currIndex === 0) {
    return length - 1;
  }
  return -1;
};

class FadeCarouselSide extends Component {
  state = {
    currIndex: 0,
    isAnimating: false,
    delay: this.props.autoPlay > 0 ? this.props.autoPlay : 0,
  };

  clickNext = () => {
    this.timerRemaining = this.state.delay;
    this.fadeTo(nextIndex(this.state.currIndex, this.props.slides.length), 1);
  }

  clickPrev = () => {
    this.fadeTo(prevIndex(this.state.currIndex, this.props.slides.length), -1);
  }

  fadeTo = (index) => {
    if(this.state.isAnimating && isTransitionSupported) return;

    this.timerStarted = new Date().getTime();
    this.setState({
      currIndex: index,
      isAnimating: true,
    });
    if(this.props.onChange) this.props.onChange(index);
  }

  clickDot = (e) => {
    if(e.target.className.indexOf(styles.dot) < 0) {
      return;
    }
    const index = parseInt(e.target.getAttribute('data-index'), 10);
    this.fadeTo(index);
  }

  setTransitionEnd = () => {
    this.setState({
      isAnimating: false,
    });
  };

  startSlideshow = (delay) => {
    if(delay > 0) {
      this.timer = setTimeout(() => {
        this.clickNext();
        this.startSlideshow(this.state.delay);
      }, delay);
      this.timerStarted = new Date().getTime();
    }
  }

  pauseSlideshow = () => {
    clearTimeout(this.timer);
    const delay = this.timerRemaining || this.state.delay;
    this.timerRemaining = delay - (new Date().getTime() - this.timerStarted);
  }

  resumeSlideshow = () => {
    this.startSlideshow(this.timerRemaining);
  }

  componentDidMount() {
    this.startSlideshow(this.state.delay);
  }

  createSlides(currIndex) {
    return this.props.slides.map((slide, i) => {
      const slideProps = {
        key: i,
        id: i,
        isActive: i === currIndex,
        desktopImg: slide.desktopImg,
        mobileImg: slide.mobileImg,
        elementImg: slide.elementImg,
        title: slide.title,
        secondTitle: slide.secondTitle,
        subtitle: slide.subtitle,
        onTransitionEnd: this.setTransitionEnd,
        url: slide.ctaUrl || slide.extUrl,
        ctaCopy: slide.cta,
      };

      return <Slide { ...slideProps }/>;
    });
  }

  createPagination(currIndex) {
    const dots = this.props.slides.map((slide, i) => {
      const isActive = currIndex === i ? styles.active : '';
      return <div className={`${styles.dot} ${isActive}`} key={i} data-index={i}></div>;
    });
    return <div className={styles.pagination} onClick={this.clickDot} > { dots } </div>;
  }

  renderSlides(slides) {
    if (slides.length > 1) {
      const arrowVerticalOffset = this.props.arrowsVerticalOffset || 0;
      const arrowRight = (<div className={`${styles.hitBox} ${styles.right}`} onClick={this.clickNext} >
        <div className={styles.arrowWrapper} ref="arrowWrapper" ><Arrow direction="right" verticalOffset={arrowVerticalOffset} /></div>
      </div>);
      const arrowLeft = (<div className={`${styles.hitBox} ${styles.left}`} onClick={this.clickPrev} >
        <div className={styles.arrowWrapper} ref="arrowWrapper" ><Arrow direction="left" verticalOffset={arrowVerticalOffset} /></div>
      </div>);
      const pagination = this.createPagination(this.state.currIndex);
      return (
        <div className={styles.slideStage} onMouseEnter={this.pauseSlideshow} onMouseLeave={this.resumeSlideshow} >
          { pagination }
          { arrowRight }
          { arrowLeft }
          { slides }
        </div>
      );
    }
    return <div className={styles.slideStage}>{ slides }</div>
  }

  render() {
    const slides = this.createSlides(this.state.currIndex);
    return this.renderSlides(slides);
  }
}

FadeCarouselSide.propTypes = {
  slides: PropTypes.array.isRequired,
  autoPlay: PropTypes.number,
  arrowsVerticalOffset: PropTypes.number,
  onChange: PropTypes.func,
};

export default FadeCarouselSide;



/** WEBPACK FOOTER **
 ** ./shared-components/FadeCarouselSide/index.js
 **/